import { ViewState } from 'app/pages/hosted-checkout/interface';
import { createContext, FC, PropsWithChildren } from 'react';

export const CheckoutFrameContext = createContext<ViewState>(null as any);

export interface CheckoutFrameProviderProps {
  state: ViewState;
}

export const CheckoutFrameProvider: FC<PropsWithChildren<CheckoutFrameProviderProps>> = ({ children, state }) => (
  <CheckoutFrameContext.Provider value={state}>{children}</CheckoutFrameContext.Provider>
);
